var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeasureBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-8 -8 36.00 36.00",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(0,0), scale(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -8,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#009fe3",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 20 L 20 20 L 0 0 z M 1 2.4160156 L 17.583984 19 L 15 19 L 15 18 L 14 18 L 14 19 L 12.998047 19 L 12.998047 18 L 12 18 L 12 19 L 11 19 L 11 18 L 10 18 L 10 19 L 9 19 L 9 18 L 8 18 L 8 19 L 7 19 L 7 18 L 6 18 L 6 19 L 5 19 L 5 18 L 4 18 L 4 19 L 3 19 L 3 18 L 2 18 L 2 19 L 1 19 L 1 2.4160156 z M 4 9.6582031 L 4 16 L 10.34375 16 L 4 9.6582031 z M 5 12.072266 L 7.9277344 15 L 5 15 L 5 12.072266 z ",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.0002
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureBg2);
export default __webpack_public_path__ + "static/media/measureBG2.0bd5314f5c3bad4051a950508384815d.svg";
export { ForwardRef as ReactComponent };